// Batch 31 · items 27 (M103) and 29 (M105): the 322(a) management letter "to be issued" line on W11 and the W12 note
// (EN + AR). Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B31_GATES = {
  en: {
    w11: {
      warnings: {
        ml_to_be_issued: "Management letter on internal control (322(a)) — to be issued by {due} (report date + 60 days). It is not needed to clear this gate; File assembly (W12) asks for the date it was issued.",
      },
    },
    w12: {
      mlIssuedMissing: "The management letter on internal control (322(a)) has no issue date yet — enter it on 322(a) before marking the file complete.",
    },
  },
  ar: {
    w11: {
      warnings: {
        ml_to_be_issued: "خطاب الإدارة بشأن الرقابة الداخلية (322(a)) — يُصدر بحلول {due} (تاريخ التقرير + 60 يومًا). لا يلزم لاجتياز هذه البوابة؛ ويطلب تجميع الملف (W12) تاريخ إصداره.",
      },
    },
    w12: {
      mlIssuedMissing: "لا يوجد تاريخ إصدار بعد لخطاب الإدارة بشأن الرقابة الداخلية (322(a)) — أدخله في 322(a) قبل تعليم الملف كمكتمل.",
    },
  },
};

export default I18N_B31_GATES;
